import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './navbar.component'

let module = angular.module('navbar', [
  uiRouter
])

.component('navbar', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/navbar/index.js